import styles from './DraggableModules.module.scss';
import { useModules } from './useModules';
import { ModuleSearch } from './ModuleSearch/ModuleSearch';
import ModuleFilter from './ModuleFilter/ModuleFilter';
import { ModulesContainer } from './ModulesContainer/ModulesContainer';
import modulesContainerStyles from './ModulesContainer/ModulesContainer.module.scss';

export const DraggableModules = () => {
  const { systemModules, nonSystemModules, isLoading } = useModules();

  if (isLoading) {
    return (
      <div className={styles.modulesList}>
        <h4>Modules</h4>
        <div className={modulesContainerStyles.modulesContainer}>
          <div>Loading modules...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modulesList}>
      <ModuleFilter />
      <ModuleSearch />
      <ModulesContainer
        nonSystemModules={nonSystemModules}
        systemModules={systemModules}
      />
    </div>
  );
};

export default DraggableModules;
